import { Component } from '@angular/core';
import { NewTopicFormComponent } from '@components/forms/new-topic-form/new-topic-form.component';

@Component({
  selector: 'app-new-topic-page',
  standalone: true,
  imports: [NewTopicFormComponent],
  templateUrl: './new-topic-page.component.html',
  styleUrl: './new-topic-page.component.scss',
})
export class NewTopicPageComponent {}
